import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EdituserclientPage } from "../edituserclient/edituserclient";

/**
 * Generated class for the RicercautenticlientPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ricercautenticlient',
  templateUrl: 'ricercautenticlient.html',
})
export class RicercautenticlientPage {
  public searchTerm;
  utenti: string[];
  errorMessage: string;
  link;
  modo="t";

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider

  ) {

    this.searchTerm=navParams.get('searchTerm');
    if(this.searchTerm!=null){
     this.setFilteredItems();
    }
  }

  setFilteredItems() {
    console.log(this.searchTerm);
    if (this.searchTerm.length > 2) {
    //  alert(this.modo);
      if(this.modo=="t")
      {
        this.rest.searcUserClient(this.searchTerm).subscribe(
          utenti => this.utenti = utenti,
          error => this.errorMessage = <any>error);
        
      }
      else if(this.modo=="c"){
        this.rest.searcUserClientCodice(this.searchTerm).subscribe(
          utenti => this.utenti = utenti,
          error => this.errorMessage = <any>error);
        

      } else if(this.modo=="e"){
        this.rest.searcUserClientEmail(this.searchTerm).subscribe(
          utenti => this.utenti = utenti,
          error => this.errorMessage = <any>error);
        

      }
    

      if (this.utenti != null) {
        this.LoadData();
      }


    }
  }
  public LoadData() {
    console.log("LoadData this.utenti:" + JSON.stringify(this.utenti));

    console.log("LoadData");

  }
  openEditUtentePage(utente) {

    this.navCtrl.push(EdituserclientPage, { userclient: utente ,searchTerm:this.searchTerm});


  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad RicercautenticlientPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/ricercautenticlient/ricercautenticlient.ts